import ScreenAppClient from './index';
import {
  AnalyticsAPI,
  TeamsAPI,
  AuthAPI,
  EmailAPI,
  IntegrationAPI,
  PluginAPI,
  RagAPI,
  SubscriptionAPI,
  TrackingAPI,
} from './api';
import { ScreenAppClientOptions } from './types';

/**
 * ScreenAppPrivateClient
 * Extended version of the public SDK that includes private APIs
 * This is for internal use only and should not be published
 */
class ScreenAppPrivateClient extends ScreenAppClient {
  // Private API instances
  public analytics: AnalyticsAPI;

  public teams: TeamsAPI;

  public auth: AuthAPI;

  public email: EmailAPI;

  public integration: IntegrationAPI;

  public plugin: PluginAPI;

  public rag: RagAPI;

  public subscription: SubscriptionAPI;

  public tracking: TrackingAPI;

  constructor(options: ScreenAppClientOptions) {
    super(options);

    // Initialize private APIs with the same axios instance
    const api = this.getApiInstance();
    this.analytics = new AnalyticsAPI(api);
    this.teams = new TeamsAPI(api);
    this.auth = new AuthAPI(api);
    this.email = new EmailAPI(api);
    this.integration = new IntegrationAPI(api);
    this.plugin = new PluginAPI(api);
    this.rag = new RagAPI(api);
    this.subscription = new SubscriptionAPI(api);
    this.tracking = new TrackingAPI(api);
  }
}

export default ScreenAppPrivateClient;
